export default "__VITE_ASSET__cscci$Z5__"